import { Component, OnInit, Renderer2 } from '@angular/core';
import { HeroBannerComponent } from '../Components/hero-banner/hero-banner.component';
import { FormsModule } from '@angular/forms';
import { CarouselComponent } from '../Components/carousel/carousel.component';
import { ActivatedRoute } from '@angular/router';
import { CreationsService } from '../Services/creations.service';
import { environment } from '../../environments/environment';

interface tiles {
  title: string;
  imageTitle: string;
  category: string;
  src: string;
  imageName: string[];
  imageTag: string[];
  imagePath: string;
}

@Component({
  selector: 'app-creationspage',
  standalone: true,
  imports: [HeroBannerComponent, FormsModule, CarouselComponent],
  templateUrl: './creationspage.component.html',
  styleUrl: './creationspage.component.scss',
})
export class CreationspageComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private creationsService: CreationsService,
    private renderer: Renderer2
  ) {}

  // tiles = creations;
  tiles: tiles[] = [];
  filteredTiles: tiles[] = [];
  selectedImages: string[] = [];

  searchTerm: string = '';

  filters: { selectedFilter: string | null } = {
    selectedFilter: null, // Set to null initially to indicate no filter is selected
  };
  public env = environment;

  ngOnInit(): void {
    this.creationsService.getCreations().subscribe((data) => {
      this.tiles = data;
      this.filteredTiles = this.tiles; // Initialize filteredTiles with all items
      this.route.queryParams.subscribe((params) => {
        const filter = params['filter'];
        if (filter) {
          this.applyFilter(filter);
        }
      });
    });
  }

  // Method to apply a filter based on the radio button selection
  applyFilter(filter: string | null) {
    this.filters.selectedFilter = filter; // Set the selected filter
    this.filterCreations();
  }

  // Method to get the display name of the selected filter for the "No content" message
  getFilterName(filter: string | null): string {
    const filterNames: { [key: string]: string } = {
      mediaWalls: 'Media Walls',
      drinksBars: 'Drinks Bars',
      offices: 'Offices',
      wardrobes: 'Wardrobes',
      commercialSpaces: 'Commercial Spaces',
      other: 'Other',
    };

    return filter ? filterNames[filter] : 'items';
  }

  // Updated filtering logic to work with the selected radio filter
  filterCreations() {
    this.filteredTiles = this.tiles.filter((item) => {
      const matchesSearch = item.imageTag[0]
        .toLowerCase()
        .includes(this.searchTerm.toLowerCase());

      // If no filter is selected, all items match the filter condition
      const matchesFilter =
        (this.filters.selectedFilter === 'mediaWalls' &&
          item.category === 'Media Walls') ||
        (this.filters.selectedFilter === 'drinksBars' &&
          item.category === 'Drinks Bars') ||
        (this.filters.selectedFilter === 'offices' &&
          item.category === 'Offices') ||
        (this.filters.selectedFilter === 'wardrobes' &&
          item.category === 'Wardrobes') ||
        (this.filters.selectedFilter === 'commercialSpaces' &&
          item.category === 'Commercial Spaces') ||
        (this.filters.selectedFilter === 'other' &&
          item.category === 'Other') ||
        this.filters.selectedFilter === null; // No filter selected shows all categories

      return matchesSearch && matchesFilter;
    });
  }

  // Method to clear the filter and show all items
  clearFilter() {
    this.filters.selectedFilter = null; // Reset the filter to null
    this.filterCreations(); // Reapply the filtering logic to show all items
  }

  getHDImagePaths(imageNames: string[], imagePath: string): string[] {
    return imageNames.map((name) =>
      imagePath === 'localhost'
        ? environment.imageLargeUrl + name
        : imagePath + '/carousel/large/' + name
    );
  }

  getImageUrl(tile: any): string {
    return tile.imagePath === 'localhost'
      ? this.env.imageMiniUrl + tile.imageName[0]
      : tile.imagePath + '/carousel/mini/' + tile.imageName[0];
  }

  openCarousel(imageNames: string[], imagePath: string): void {
    this.selectedImages = this.getHDImagePaths(imageNames, imagePath); // Set HD images for carousel
    this.renderer.addClass(document.body, 'no-scroll');
  }

  trackByIndex(index: number, item: any): any {
    return index;
  }
}
